import { render, staticRenderFns } from "./problem_multi_sn.vue?vue&type=template&id=0bf28fa6&"
import script from "./problem_multi_sn.vue?vue&type=script&lang=js&"
export * from "./problem_multi_sn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports